import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../../views/BookingApp/UserView/Home.vue'
import Login from '../../views/BookingApp/UserView/Login.vue'
import PickATime from '../../views/BookingApp/UserView/PickATime.vue'
import ContactDetails from '../../views/BookingApp/UserView/ContactDetails.vue'
import ChooseACategory from '../../views/BookingApp/UserView/ChooseACategory.vue'
import ChooseATreatment from '../../views/BookingApp/UserView/ChooseATreatment.vue'
import BookingCompleted from '../../views/BookingApp/UserView/BookingCompleted.vue'
import adminRoutes from './adminRoutes';

Vue.use(VueRouter)

const defaultRoutes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/category',
        name: 'Categories',
        component: ChooseACategory,
    },
    {
        path: '/category/:id',
        name: 'CategorySelection',
        component: ChooseATreatment,

    },
    {
        path: '/category/:id/:treatId',
        name: 'pickATime2',
        component: PickATime
    },
    {
        path: '/contact-details',
        name: 'contactDetails',
        component: ContactDetails
    },
    {
        path: '/booking-completed',
        name: 'bookingCompleted',
        component: BookingCompleted
    },

]

var allRoutes = [];
allRoutes = allRoutes.concat(defaultRoutes, adminRoutes);
const routes = allRoutes;

const routerForBookingApp = new VueRouter({
    // TODO always mode abstract in PROD! otherwise a circular load js reference could occur
    mode: 'abstract',
    routes
});
routerForBookingApp.push('/category');

export default routerForBookingApp
